import { render, staticRenderFns } from "./evaluationScale.vue?vue&type=template&id=68c23593&scoped=true&"
import script from "./evaluationScale.vue?vue&type=script&lang=js&"
export * from "./evaluationScale.vue?vue&type=script&lang=js&"
import style0 from "./evaluationScale.vue?vue&type=style&index=0&id=68c23593&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c23593",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContent,VRow})
